import React, { useEffect } from "react";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NavbarMenu = () => {
  const { pathname } = useLocation();

  const { t } = useTranslation();

  useEffect(() => {
    const li = document.querySelectorAll(".nav_menu_btn");
    li.forEach((l) => {
      l?.addEventListener("click", (e: any) => {
        l.classList.remove("active");
      });
    });
  }, []);
  return (
    <div className="nav_menu">
      <ul>
        <li>
          <Button className="nav_menu_btn">
            <a href="/#asosiy">
              <div data-aos="fade-right">{t("NAVBARMENU.MAIN")}</div>
            </a>
          </Button>
        </li>

        <li>
          <Button className="nav_menu_btn">
            <a href="/#imkoniyat">
              <div data-aos="fade-right">{t("NAVBARMENU.CHANCES")}</div>
            </a>
          </Button>
        </li>

        <li>
          <Button className="nav_menu_btn">
            <a href="/#product">
              <div data-aos="fade-down">{t("NAVBARMENU.PRODUCT")}</div>
            </a>
          </Button>
        </li>

        <li>
          <Button className="nav_menu_btn">
            <a href="/#about">
              <div data-aos="fade-left">{t("NAVBARMENU.ABOUTUS")}</div>
            </a>
          </Button>
        </li>

        <li>
          <Button className="nav_menu_btn">
            <a href="/#galery">
              <div data-aos="fade-left">{t("NAVBARMENU.GALLERY")}</div>
            </a>
          </Button>
        </li>
      </ul>
    </div>
  );
};

export default NavbarMenu;
